import { Governance } from "@/widgets/governance"

export const GovernancePage = () => <Governance />
